package com.essntl.features.area.ui.addeditarea.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.area.ui.addeditarea.AddEditAreaEvent
import com.essntl.features.area.ui.addeditarea.AddEditAreaScreen
import com.essntl.features.area.ui.addeditarea.AddEditAreaState
import com.essntl.features.area.ui.addeditarea.AddEditAreaValidation
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AddEditAreaDialog(
    openDialog: Boolean,
    currentArea: AreaModel? = null,
    state: AddEditAreaState,
    validation: AddEditAreaValidation,
    onEvent: (AddEditAreaEvent) -> Unit,
    onDismissRequest: () -> Unit,
    modifier: Modifier = Modifier,
) {
    LaunchedEffect(openDialog) {
        if (openDialog) {
            onEvent(AddEditAreaEvent.ClearState)
            onEvent(AddEditAreaEvent.GetAllCountries)
            if (currentArea != null)
                onEvent(AddEditAreaEvent.GetArea(currentArea.id))
        }
    }

    if (openDialog)
        BasicAlertDialog(
            onDismissRequest = onDismissRequest,
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(25.dp)),
            ) {
                Column(
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(color = Color.White),
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(color = MaterialTheme.esColorScheme.bgPrimary)
                            .padding(vertical = 3.spacing, horizontal = 2.5.spacing),
                    ) {
                        Text(
                            text = if (currentArea != null) "Edit area" else "Add new area",
                            style = MaterialTheme.esTypography.h3Bold24,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            modifier = Modifier.align(Alignment.CenterStart),
                        )

                        EsSmallOutlineIconButton(
                            onClick = {
                                onDismissRequest()
                            },
                            iconRes = EsIcons.Close,
                            modifier = Modifier.align(Alignment.CenterEnd),
                        )
                    }

                    AddEditAreaScreen(
                        state = state,
                        validation = validation,
                        onEvent = onEvent,
                    )
                }
            }
        }
}